module.exports = __webpack_public_path__ + "static/media/logos-harinera anahuac.85f066df.png";